export const initialFileData = {
  billOfLading: "",
  otherDoc: "",
};
